import { combineReducers } from "redux";
import { LoginModalReducer } from "./loginreducers";

const rootReducer = combineReducers({
    LoginModalReducer
})
export default rootReducer;